import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { faChevronDown, faCheck, faCopy, faPrint } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import copy from "copy-to-clipboard";
import { useState } from "react";
import AwesomeIcon from "../../../AwesomeIcon";
import { CARD_SECTION, CARD_SECTION_LABEL } from "./cardStyles";
// Highlight color mirrors RadiologyReportMessage: #7a5000 light / #fcd26c dark
var processReport = function processReport(raw) {
  return raw.replace(/<highlighted_text>([^]*?)<\/highlighted_text>/g, function (_, p1) {
    return "<span class=\"text-[#7a5000] dark:text-[#fcd26c] font-semibold\">".concat(p1, "</span>");
  });
};
var hasValue = function hasValue(value) {
  return Array.isArray(value) ? value.length > 0 : !!value && value.trim() !== "";
};
var snakeToTitle = function snakeToTitle(key) {
  return key.split("_").map(function (w) {
    return w.charAt(0).toUpperCase() + w.slice(1);
  }).join(" ");
};
var SECTION_LABEL = "".concat(CARD_SECTION_LABEL, " mb-2");
var SECTION_WRAP = "flex flex-wrap gap-2";
var MetaPill = function MetaPill(_ref) {
  var label = _ref.label,
    value = _ref.value,
    isAccented = _ref.isAccented;
  var _useState = useState(false),
    copied = _useState[0],
    setCopied = _useState[1];
  if (!hasValue(value)) return null;
  var text = Array.isArray(value) ? value.join(", ") : value;
  var onCopy = function onCopy(e) {
    e.stopPropagation();
    copy(text, {
      format: "text/plain"
    });
    setCopied(true);
    setTimeout(function () {
      return setCopied(false);
    }, 1200);
    // Drop focus so the button hides again once the pointer leaves the pill
    e.currentTarget.blur();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "group inline-flex items-center gap-1.5 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md px-3 py-1 whitespace-nowrap"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[9px] font-semibold uppercase tracking-[0.06em] text-gray-400 dark:text-gray-500"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: classNames("text-[11px] font-medium", isAccented ? "text-teal-600 dark:text-teal-400" : "text-gray-800 dark:text-gray-200")
  }, text), /*#__PURE__*/React.createElement("button", {
    onClick: onCopy,
    title: copied ? "Copied" : "Copy ".concat(label),
    "aria-label": "Copy ".concat(label),
    className: classNames("flex items-center justify-center w-[14px] h-[14px] -mr-1 transition-opacity duration-150 focus:opacity-100 focus:outline-none", copied ? "opacity-100 text-teal-600 dark:text-teal-400" : "opacity-0 group-hover:opacity-100 text-gray-400 hover:text-teal-600 dark:hover:text-teal-400")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: copied ? faCheck : faCopy,
    className: "w-[10px] h-[10px]"
  })));
};
var SECTION = CARD_SECTION;
var ActionButton = function ActionButton(_ref2) {
  var icon = _ref2.icon,
    title = _ref2.title,
    _onClick = _ref2.onClick,
    isActive = _ref2.isActive;
  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick();
    },
    title: title,
    className: classNames("flex items-center justify-center w-[22px] h-[22px] rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 transition-colors duration-150 shadow-sm", isActive ? "text-teal-600 dark:text-teal-400 border-teal-200 dark:border-teal-800" : "text-gray-600 dark:text-gray-300 hover:text-teal-600 dark:hover:text-teal-400 hover:bg-teal-50 dark:hover:bg-teal-900/30")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: icon,
    className: "w-[10px] h-[10px]"
  }));
};
var ReportVersionPanel = function ReportVersionPanel(_ref3) {
  var version = _ref3.version,
    onPrint = _ref3.onPrint,
    onCopy = _ref3.onCopy;
  var _useState2 = useState(false),
    isAdditionalOpen = _useState2[0],
    setIsAdditionalOpen = _useState2[1];
  var _useState3 = useState(false),
    reportCopied = _useState3[0],
    setReportCopied = _useState3[1];
  var metadata = version.metadata,
    additional = version.additional,
    reportHtml = version.reportHtml;
  var showActions = !!onPrint && !!onCopy;
  var handleCopy = function handleCopy() {
    onCopy === null || onCopy === void 0 || onCopy();
    setReportCopied(true);
    setTimeout(function () {
      return setReportCopied(false);
    }, 1500);
  };
  var hasMetadata = hasValue(metadata.acc) || hasValue(metadata.radiologists) || hasValue(metadata.referring) || hasValue(metadata.ordering) || hasValue(metadata.patientClass) || hasValue(metadata.facility);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("px-[14px] pt-[10px] pb-[8px] max-h-[280px] overflow-y-auto scrollbar-light dark:scrollbar", showActions && "pr-[58px]")
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-left text-[14px] leading-[22px] text-gray-700 dark:text-gray-200 break-words whitespace-pre-wrap",
    dangerouslySetInnerHTML: {
      __html: processReport(reportHtml)
    }
  })), showActions && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-[5px] right-[8px] flex gap-0.5 z-10"
  }, /*#__PURE__*/React.createElement(ActionButton, {
    icon: faPrint,
    title: "Print",
    onClick: onPrint
  }), /*#__PURE__*/React.createElement(ActionButton, {
    icon: reportCopied ? faCheck : faCopy,
    title: reportCopied ? "Copied" : "Copy",
    onClick: handleCopy,
    isActive: reportCopied
  }))), hasMetadata && /*#__PURE__*/React.createElement("div", {
    className: SECTION
  }, /*#__PURE__*/React.createElement("div", {
    className: SECTION_WRAP
  }, /*#__PURE__*/React.createElement(MetaPill, {
    label: "ACC",
    value: metadata.acc
  }), /*#__PURE__*/React.createElement(MetaPill, {
    label: "Radiologists",
    value: metadata.radiologists
  }), /*#__PURE__*/React.createElement(MetaPill, {
    label: "Referring",
    value: metadata.referring
  }), /*#__PURE__*/React.createElement(MetaPill, {
    label: "Ordering",
    value: metadata.ordering
  }), /*#__PURE__*/React.createElement(MetaPill, {
    label: "Patient Class",
    value: metadata.patientClass
  }), /*#__PURE__*/React.createElement(MetaPill, {
    label: "Facility",
    value: metadata.facility
  }))), Object.keys(additional).length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-50 dark:bg-gray-800/60 border-t border-gray-200 dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("button", {
    className: "flex w-full items-center px-4 py-2 text-[9px] font-semibold tracking-[0.07em] uppercase text-gray-400 dark:text-gray-500 hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-150",
    onClick: function onClick() {
      return setIsAdditionalOpen(function (prev) {
        return !prev;
      });
    }
  }, "Additional", /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronDown,
    className: classNames("w-[11px] h-[11px] ml-auto transition-transform duration-200 ease-in-out", {
      "rotate-180": isAdditionalOpen
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames("grid transition-[grid-template-rows] duration-200 ease-in-out", isAdditionalOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]")
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden min-h-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 pb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: SECTION_WRAP + " pt-1"
  }, Object.entries(additional).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      val = _ref5[1];
    return /*#__PURE__*/React.createElement(MetaPill, {
      key: key,
      label: snakeToTitle(key),
      value: val
    });
  })))))));
};
export default ReportVersionPanel;